import React, { useEffect } from "react";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function ToActAsPilotSix({ templateName }: { templateName: string }) {
    const user = useAppSelector(getUser)
    const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
    const [firstLastName, setFirstLastName] = React.useState("")
    const [grade, setGrade] = React.useState("")
    const [airplane, setAirplane] = React.useState("")
    const dispatch = useDispatch()
    useEffect(() => {
        const templateText = `I certified that ${name} [First name, MI, Last name], ${firstLastName} [grade of pilot certificate], ${grade} has received the required training of §61.31(i) in a ${airplane} tailwheel airplane. I have determined that [he or she] is proficient in the operation and systems of a tailwheel airplane.`
        dispatch(setTemplateText(templateText))
    }, [name, grade, airplane, dispatch])
    return (
        <TemplateLayout templateName={templateName}>
            <div className="col-12 my-2">
                <label>Relevant FAR:61.31(g)(1)</label>
            </div>

            <div className="col-12 my-2">
                <p className="certificate_text">
                    I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> [First name, MI, Last name], <input type="text" onChange={(e) => setFirstLastName(e.target.value)} /> [grade of pilot certificate], <input type="text" onChange={(e) => setGrade(e.target.value)} /> has received the required training of §61.31(i) in a <input type="text" onChange={(e) => setAirplane(e.target.value)} /> tailwheel airplane. I have determined that [he or she] is proficient in the operation and systems of a tailwheel airplane.
                </p>
            </div>
        </TemplateLayout>
    );
}

export default ToActAsPilotSix;
